import { Gift } from "lucide-react";
import { useState, useEffect } from "react";
import { toast } from "sonner";

import { carregarPrograma } from "./api/referralApi";
import CodigoIndicacao from "./components/CodigoIndicacao";
import ComoFunciona from "./components/ComoFunciona";
import ListaIndicados from "./components/ListaIndicados";
import ResumoMeses from "./components/ResumoMeses";

/**
 * Indique e Ganhe — modelo de 2 mensalidades gratuitas.
 *
 * Substitui a versao de comissao em dinheiro (10/18/25% recorrente), que nunca
 * chegou a ficar visivel: a pagina inteira estava atras de um card "Em breve".
 * O que o lojista via era uma promessa de comissao que o backend nao pagava.
 */
export default function IndiqueGanhePage() {
  const [loading, setLoading] = useState(true);
  const [dados, setDados] = useState({ code: "", link: "", resumo: {}, indicados: [] });

  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const d = await carregarPrograma();
        if (vivo) setDados(d);
      } catch {
        if (vivo) toast.error("Não consegui carregar seu programa de indicação.");
      } finally {
        if (vivo) setLoading(false);
      }
    })();
    return () => {
      vivo = false;
    };
  }, []);

  // Vem do backend pra regra ter UMA fonte: mudar o numero la' muda a tela toda.
  const mesesPorIndicacao = dados.resumo?.meses_por_indicacao ?? 2;

  return (
    <div className="p-4 sm:p-6 space-y-6 max-w-6xl mx-auto">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Gift className="w-6 h-6 text-primary" />
          <h1 className="text-2xl sm:text-3xl font-bold">Indique e Ganhe</h1>
        </div>
        <p className="text-muted-foreground">
          Indique o Núcleo para outro estabelecimento. Quando ele pagar a
          primeira mensalidade, você ganha{" "}
          <strong className="text-foreground">
            {mesesPorIndicacao} mensalidades grátis
          </strong>
          .
        </p>
      </div>

      <ResumoMeses resumo={dados.resumo} loading={loading} />

      <CodigoIndicacao
        code={dados.code}
        link={dados.link}
        mesesPorIndicacao={mesesPorIndicacao}
        loading={loading}
      />

      <ListaIndicados
        indicados={dados.indicados}
        mesesPorIndicacao={mesesPorIndicacao}
        loading={loading}
      />

      <ComoFunciona mesesPorIndicacao={mesesPorIndicacao} />
    </div>
  );
}
